export function searchedTextInBold(line?: string, searchedText?: Nullable<string>) {
  if (searchedText === null) {
    return <>{line}</>;
  }
  const indexOf = (line ?? '').toLowerCase().indexOf((searchedText ?? '').toLowerCase());
  if (indexOf === -1) {
    return <>{line}</>;
  }
  const before = line?.slice(0, indexOf);
  const matched = line?.slice(indexOf, indexOf + (searchedText ?? '').length);
  const after = line?.slice(indexOf + (searchedText ?? '').length);

  return (
    <>
      {before}
      <b>{matched}</b>
      {after}
    </>
  );
}

export interface SearchResultItemProps<Item> {
  item: Item;
  searchedText: Nullable<string>;
  isSelected: boolean;
  onSelected: (value: Item) => void;
  getError?: (value: Item) => string[];
}
